<template>
  <div class="content">
    <div class="row">
      <div :class="[{ 'col-lg-9 col-md-7': showSettings },{ 'col-lg-12': !showSettings }]">
        <network
          class="network"
          ref="network"
          :nodes="getNetworkGraphNodes"
          :edges="getNetworkGraphEdges"
          :options="solverOptions"
          @double-click="addAccount($refs.network.getSelection().nodes[0])"
          @click="showAccountInfo($refs.network.getSelection(), filters.direction, true)">
        </network>
        <div class="row font-size-sm network-footer">
          <div class="col-sm-6 order-sm-2 mb-1 mb-sm-0 text-center text-sm-right">
            <a @click="togglePpModal(true)" href="javascript:void(0)">{{$t('layout.pageFooter.privacyPolicy')}}</a> <span class="mx-1"> | </span>
            {{$t('layout.pageFooter.craftedWith')}} <i class="fa fa-heart text-danger"></i> {{$t('layout.pageFooter.by')}} <a class="font-w600" href="https://eosnation.io" target="_blank">{{$t('layout.pageFooter.eosNation')}}</a>
          </div>
          <div class="col-sm-6 order-sm-1 text-center text-sm-left">
            <router-link :to="{ name: 'dashboard' }" class="font-w600">{{$t('layout.pageFooter.' + selectedChain)}} {{$t('layout.pageFooter.detective')}}</router-link> &copy; 2019
          </div>
        </div>
      </div>
      <div v-if="showSettings" class="col-lg-3 col-md-5 physicsSettings">
        <physics-options/>
      </div>
    </div>
    <account-info-modal/>
    <edge-info-modal/>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
import { Network } from 'vue2vis'
import AccountInfoModal from './AccountInfoModal'
import EdgeInfoModal from './EdgeInfoModal'
import PhysicsOptions from './PhysicsOptions'

export default {
  components: {
    PhysicsOptions,
    Network,
    AccountInfoModal,
    EdgeInfoModal
  },
  created () {
    if (!this.hasLoadedOnce) {
      this.setLoading(true)
      this.$store.dispatch('addAccounts', { accounts: this.$route.query.accounts.split('-'), reset: false })
      Object.entries(this.$route.query).forEach(([key, val]) => {
        if (key === 'accounts') return
        if (['time_min', 'time_max'].includes(key)) {
          this.$store.commit('updateFilter', { key: key, value: this.convertDate(val, 'date') })
          this.$store.commit('updateFilter', { key: key + '_time', value: this.convertDate(val, 'time') })
          this.$store.commit('updateFilter', { key: 'time_min_pre', value: 'custom' })
        } else if (key === 'excludedAccounts') {
          this.$store.commit('updateFilter', { key: key, value: val.split('-').filter(it => it).map(it => { return { text: it } }) })
        } else if (key === 'excludedCategories') {
          this.$store.commit('updateFilter', { key: key, value: val.split('-').filter(it => it) })
        } else {
          this.$store.commit('updateFilter', { key: key, value: val })
        }
      })
    }
  },
  computed: {
    solverOptions () {
      return this.$store.getters.solverOptions
    },
    getNetworkGraphNodes () {
      return this.$store.getters.getNetworkGraphNodes
    },
    getNetworkGraphEdges () {
      return this.$store.getters.getNetworkGraphEdges
    },
    showSettings () {
      return this.$store.state.options.network.showSettings
    },
    modal () {
      return this.$store.state.network.modal
    },
    search: {
      // getter
      get () {
        return this.$store.state.filter.search
      },
      // setter
      set (value) {
        this.$store.commit('setSearch', value)
      }
    },
    network () {
      return this.$store.state.network.network
    },
    filters () {
      return this.$store.state.filter.filters
    },
    hasLoadedOnce () {
      return this.$store.state.filter.hasLoadedOnce
    },
    userApiToken () {
      return this.$store.state.auth.profile.userApiToken
    },
    selectedChain () {
      return this.$store.state.options.selectedChain
    }
  },
  methods: {
    ...mapMutations([
      'toggleEdgeModal',
      'toggleNodeModal',
      'setLoading',
      'togglePpModal'
    ]),
    convertDate (obj, format) {
      let date = new Date(parseInt(obj))
      let day = date.getDate()
      let month = date.getMonth() + 1
      let year = date.getFullYear()
      let hour = date.getHours()
      let minute = date.getMinutes()
      if (day < 10) {
        day = '0' + day
      }
      if (month < 10) {
        month = '0' + month
      }
      if (hour < 10) {
        hour = '0' + hour
      }
      if (minute < 10) {
        minute = '0' + minute
      }
      if (format === 'date') return year + '-' + month + '-' + day
      if (format === 'time') return hour + ':' + minute
    },
    addAccount (account) {
      this.$store.commit('setAllowSingleClick', false)
      if (typeof account !== 'undefined') {
        this.$store.dispatch('addAccounts', { accounts: [account], reset: false })
        this.getResults()
          .then(() => {
            this.$router.push({
              name: 'NetworkGraphNetwork',
              query: this.$store.getters.getRouteParams
            })
          })
          .catch(() => {
            this.$store.dispatch('addAccounts', { accounts: this.$route.query.accounts.split('-'), reset: true })
          })
      }
    },
    getResults () {
      return new Promise((resolve, reject) => {
        this.$store.dispatch('loadNetworkGraphData')
          .then(() => { resolve() })
          .catch((error) => { reject(error) })
      })
    },
    showAccountInfo (account, direction, accumulated) {
      setTimeout(() => {
        // Load Edge Transfer
        if (typeof account.nodes[0] === 'undefined' && typeof account.edges[0] !== 'undefined' && this.network.allowSingleClick) {
          this.$store.dispatch('loadAccountData', { account: account.edges[0].split('-'), direction: 'between', accumulated: false })
          this.toggleEdgeModal(true)
          // Load Node Transfer
        } else if (typeof account.nodes[0] !== 'undefined' && typeof account.edges[0] !== 'undefined' && this.network.allowSingleClick) {
          this.$store.dispatch('loadAccountData', { account: account.nodes, direction: 'both', accumulated: accumulated })
          this.toggleNodeModal(true)
        }
      }, 200)
    }
  },
  watch: {
    userApiToken () {
      this.getResults()
    }
  },
  beforeDestroy () {
    // this.$store.commit('resetNetwork')
  }
}
</script>

<style scoped lang="scss">
  .network {
    height: calc(100vh - 70px);
    margin: -1.75rem;
  }
  .physicsSettings {
    overflow: scroll;
    padding-left: 1.75rem;
    height: calc(100vh - 170px);
  }
</style>
